@if (!isStandaloneValue) {
	<input type="hidden" class="form-control" [ngClass]="{ 'is-invalid': control && control?.invalid && control?.touched }" [class]="customClass" [formControlName]="controlName" />
}

@if (isStandaloneValue) {
	<input type="hidden" class="form-control" [ngClass]="{ 'is-invalid': control && control?.invalid && control?.touched }" [class]="customClass" />
}

<input
	type="text"
	[readOnly]="disableSearch"
	(input)="filterValue($event.target)"
	(click)="onInputClick()"
	[value]="selectedLabel"
	class="form-control custom-select-input mb-0"
	[attr.data-cy]="controlName"
	[disabled]="disabled"
	[placeholder]="placeHolder"
	[ngClass]="{ 'is-invalid': (openedOnce && control && control?.invalid) || (control && control?.invalid && control?.touched), opened: activeList, 'search-cursor': !disableSearch }"
	[class]="customClass"
	(blur)="onBlur()"
/>

@if (hasClearButton && selectedLabel) {
	<span class="clear-btn" (click)="clearSelection()"> &#x2715; </span>
}

<ul [ngClass]="{ active: activeList }" class="custom-select-list">
	@if (multiple) {
		@for (item of items; track item) {
			<li>
				<label>
					<input type="checkbox" class="form-check-input" [checked]="isSelected(item)" (change)="toggleSelection(item)" />
					{{ getValue(item) }}
				</label>
			</li>
		}
	} @else {
		@for (item of items; track item) {
			<li (click)="select(item)">
				@if (customTemplate && headerTemplateRef) {
					<ng-container *ngTemplateOutlet="headerTemplateRef; context: { $implicit: item }"></ng-container>
				} @else {
					{{ getValue(item) }}
				}
			</li>
		}
	}

	@if (itemsNotFound) {
		<li>No se encontraron resultados</li>
	}
</ul>
